export const translations = {
  'Monday': 'Dushanba',
  'Tuesday': 'Seshanba',
  "Wednesday": "Chorshanba",
  "Thursday": "Payshanba",
  "Friday": "Juma",
  "Saturday": "Shanba",
  "Sunday": "Yakshanba",
  "Day 1": "Kun 1",
  "Day 2": "Kun 2",
  "Day 3": "Kun 3",
  "Day 4": "Kun 4",
  "Day 5": "Kun 5",
  "Day 6": "Kun 6",
  "Day 7": "Kun 7",
  "Day 8": "Kun 8",
  "Day 9": "Kun 9",
  "Day 10": "Kun 10",
  "Day 11": "Kun 11",
  "Day 12": "Kun 12",
  "Day 13": "Kun 13",
  "Day 14": "Kun 14",
  "Day 15": "Kun 15",
  "Day 16": "Kun 16",
  "Day 17": "Kun 17",
  "Day 18": "Kun 18",
  "Day 19": "Kun 19",
  "Day 20": "Kun 20",
  "Day 21": "Kun 21",
  "Day 22": "Kun 22",
  "Day 23": "Kun 23",
  "Day 24": "Kun 24",
  "Day 25": "Kun 25",
  "Day 26": "Kun 26",
  "Day 27": "Kun 27",
  "Day 28": "Kun 28",
  "Day 29": "Kun 29",
  "Day 30": "Kun 30",
  "Day 31": "Kun 31",
  "January": "Yanvar",
  "February": "Fevral",
  "March": "Mart",
  "April": "Aprel",
  "May": "May",
  "June": "Iyun",
  "July": "Iyul",
  "August": "Avgust",
  "September": "Sentabr",
  "October": "Oktabr",
  "November": "Noyabr",
  "December": "Dekabr",
}